import { safeGet } from "../utils/safeGet";
import { API } from "./index";

export const getAlergenos = async () => {
  return safeGet(`${API}/alergeno/public`, false); // false = no usar autenticación
};

export const getAlergenoById = async (id) => {
  return safeGet(`${API}/alergeno/${id}`);
};

